import './trades-upload.scss'

import { InboxOutlined } from '@ant-design/icons'
import { Button, message, Modal, Space, Upload } from 'antd'
import { DraggerProps } from 'antd/lib/upload'
import csvParse from 'csv-parse/lib/browser'
import React, { useState } from 'react'

import { buildCsvJsonContent } from '../../../components/LoadFile/csv-handler'
import { momentDateHandler } from '../../../date/moment-date-handler'
import { EditableTable } from './EditableTradesTable'

const { transformDateToIsoFormat } = momentDateHandler
const { Dragger } = Upload

const draggerConfiguration: DraggerProps = {
  name: 'file',
  accept: '.csv',
  multiple: false,
  showUploadList: false,
  maxCount: 1,
  onChange(info) {
    const { status } = info.file

    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`)
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`)
    }
  },
}

interface Props {
  onUploadClick: ({ holdings }) => void
  onCancel: () => void
  visible: boolean
}

export const UploadTradesModal = ({ onCancel, onUploadClick, visible }: Props) => {
  const [uploading, setIsUploading] = useState(false)
  const [holdings, setHoldings] = useState([])

  const uploadProps = {
    ...draggerConfiguration,
    onRemove: () => {
      setHoldings([])
    },
    beforeUpload: (file: any) => {
      const reader = new FileReader()
      reader.readAsBinaryString(file)

      reader.onload = async () => {
        csvParse(
          reader.result as any,
          {
            ltrim: true,
            delimiter: ',',
          },
          (err, output) => {
            const holdings = buildCsvJsonContent(output)
            setHoldings(
              holdings.map((holding: any, key) => ({
                key,
                ...holding,
                maturityDate: transformDateToIsoFormat(holding.maturityDate),
                purchaseDate: transformDateToIsoFormat(holding.purchaseDate),
              })),
            )
          },
        )
      }

      return false
    },
  }

  const onUpload = async () => {
    setIsUploading(true)
    onUploadClick({ holdings })
    setIsUploading(false)
  }

  const onCancelClick = () => {
    onCancel()
    setHoldings([])
  }

  return (
    <Modal
      title="Upload trades"
      onCancel={onCancelClick}
      open={visible}
      width="80vw"
      className="editable-trades"
      footer={[
        <div className="footer">
          <a href="upload-trades-sample.csv">Download Sample CSV File</a>

          <Button type="primary" onClick={onUpload} disabled={!holdings.length} loading={uploading}>
            {uploading ? 'Uploading' : 'Start Upload'}
          </Button>
        </div>,
      ]}
    >
      <Space direction="vertical" size="large" className="full-width">
        <Dragger {...uploadProps}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">Add tenant trades CSV file</p>
        </Dragger>
        <EditableTable holdings={holdings} />
      </Space>
    </Modal>
  )
}
